import React from "react";

import {
  Column,
  Divider,
  LanguageSwitcherButton,
  LinkList,
  Row,
  Select,
  LanguageSwitcherOption,
  ILangOption,
} from "../../components";
import {
  ApplePayIcon,
  GooglePayIcon,
  MastercardIcon,
  PayPalIcon,
  VisaIcon,
} from "../../icons";
import { mockedLanguages } from "../../mock/languages";

function ShortFooter() {
  return (
    <footer>
      <Divider classes={{ root: " d-none d-lg-block mb-0" }} />
      <Row
        classes={{
          root: "my-7 my-lg-5 text-desc fw-medium align-items-center",
        }}
      >
        {/* payment icons */}
        <Column classes={{ root: "col-12 col-lg-4 order-lg-1 mb-6 mb-lg-0" }}>
          <div
            className="d-flex
            align-items-center
            justify-content-between justify-content-lg-center"
          >
            <PayPalIcon className="me-lg-7" />
            <MastercardIcon className="me-lg-7" />
            <VisaIcon className="me-lg-7" />
            <ApplePayIcon className="me-lg-7" />
            <GooglePayIcon className="me-lg-7" />
          </div>
        </Column>

        {/* copyright */}
        <Column classes={{ root: "col-12 col-lg-6 mb-6 mb-lg-0 text-small" }}>
          <Row>
            <Column
              xs={12}
              classes={{ root: "col-lg-auto me-lg-7 mb-4 mb-lg-0" }}
            >
              © Copyright INTERSPORT 2021
            </Column>

            <Column xs={12} classes={{ root: "col-lg-auto" }}>
              <LinkList
                classes={{
                  root: "d-flex list-unstyled m-0 p-0",
                  listItem: "me-6",
                  link: "text-decoration-none text-color-blue",
                }}
                linksItems={[
                  {
                    text: "Terms & Conditions",
                    href: "#",
                    classes: { root: " uds-dot" },
                  },
                  {
                    text: "Privacy",
                    href: "#",
                    classes: { root: " uds-dot" },
                  },
                  { text: "Cookies", href: "#" },
                ]}
              />
            </Column>
          </Row>
        </Column>

        {/* Language select */}
        <Column
          lg={{ colSize: 2, colOrder: 2 }}
          classes={{
            root: " align-items-center justify-content-end",
          }}
        >
          <div>
            <Select<ILangOption>
              theme="dark"
              value="1"
              options={mockedLanguages}
              dropdownSize="none"
              mobilePlaceholder="Select preferred language"
              placeholder="Language"
              customButtonContentRender={LanguageSwitcherButton}
              customOptionRender={LanguageSwitcherOption}
              classes={{
                root: "language-switcher language-switcher--footer",
                button: "text-regular",
              }}
            />
          </div>
        </Column>
      </Row>
    </footer>
  );
}

export default ShortFooter;
